import { Directive, forwardRef, Attribute } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appRequiredIfNot][formControlName]',
  providers: [
      { provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredIfNotDirective), multi: true }
  ]
})
export class RequiredIfNotDirective {
    constructor(@Attribute('appRequiredIfNot') public requiredFieldName: string) {}
    
    validate(c: AbstractControl): { [key: string]: any } {
        const e = c.root.get(this.requiredFieldName);
        if (e && !e.value && c.value) {return {
            appRequiredIfNot: false
        };}
        return null;
    }
}